import { Curtain } from '@pp/core/src/components/curtain/Curtain';
import { PopupType } from '@pp/core/src/components/popup/types';
// import { UserSession } from '@pp/core/src/config/UserSession';
import { BaseCoreGameCommunicationProcessor } from '@pp/core/src/controllers/gameCommunication/processors/BaseCoreGameCommunicationProcessor';
import { GameCommunicationMessageType } from '@pp/core/src/controllers/gameCommunication/types';
// import { SessionStorage } from '@pp/core/src/storage/session/SessionStorage';
import { CoreStoreType } from '@pp/core/src/store/CoreStore';
import { gameStateActions } from '@pp/core/src/store/slices/game/slice';
import { popupActions } from '@pp/core/src/store/slices/popup/slice';
import { settingsActions } from '@pp/core/src/store/slices/settings/slice';
import { getWindowObject } from '@pp/core/src/utils/window';

import { HIGHFLYER_PT } from '../../../config';

export interface SeatMessage extends GameCommunicationMessageType {
  seats_taken: string;
  user_id: string;
  idle: boolean;
  event: string;
  table_id: string;
  type: string;
}

export class GameCommunicationSeatProcessor extends BaseCoreGameCommunicationProcessor {
  messageName = 'seat';

  process(message: SeatMessage, store: CoreStoreType): void {
    const tableVariant = store.getState().config.tableConfig?.tableVariant;
    const windowObject = getWindowObject();
    if (message.event == 'before_stand' && message.idle) {
      store.dispatch(popupActions.pushPopup(PopupType.BeforeInactivity));
    }

    if (message.event == 'stand' && message.idle) {
      store.dispatch(popupActions.pushPopup(PopupType.Inactivity));
      // Pause Game stream and game socket if inactivity limit is reached
      store.dispatch(gameStateActions.setGamePaused(true));
      store.dispatch(gameStateActions.resetCurrentGameStatus());

      if (tableVariant === HIGHFLYER_PT) {
        Curtain.resurrect();
        store.dispatch(popupActions.dismissCurrentPopup());
        store.dispatch(popupActions.overwritePopup(PopupType.SessionExpired));
        store.dispatch(gameStateActions.setGameAbandoned(true));
        store.dispatch(settingsActions.mute());
        // SessionStorage.setJson(UserSession.sessionKey, {});
        windowObject.history.replaceState({}, '', windowObject.location.pathname);
      }
    }
  }
}
